module.exports = __webpack_public_path__ + "assets/img/travel3.02337480.png";